"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductListTable = exports.columns = exports.packageAcolumns = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var lets_trade_utils_1 = require("lets-trade-utils");
var react_1 = require("react");
var pages_1 = require("../../../../../../constants/pages");
var table_top_bar_1 = require("../../../../../../components/table_top_bar");
var react_2 = require("@nextui-org/react");
var table_bottom_content_1 = require("../../../../../../components/table_bottom_content");
var tabel_cell_1 = require("../../../../../../components/tabel_cell");
var react_redux_1 = require("react-redux");
var get_products_shopify_thunk_1 = require("../../../../../../reducers/slices/products/thunks/get_products_shopify_thunk");
var current_page_items_1 = require("../../deal_and_voucher_helpers/current_page_items");
var useMemoizedCallback_1 = require("../../../../../../helpers/useMemoizedCallback");
var local_storage_names_1 = require("../../../../../../constants/local_storage_names");
var constants_1 = require("../constants");
var copy_text_1 = require("../../../../../../components/copy_text");
var main_1 = require("../../../../../../reducers/slices/main");
var add_products_component_1 = __importDefault(require("../../components/add_products_component"));
exports.packageAcolumns = [
    { name: "Image", uid: "image_url" },
    { name: "SKU", uid: "sku" },
    { name: "PID", uid: "pid" },
    { name: "Title", uid: "title" },
    { name: "Price", uid: "price" },
    { name: "Available", uid: "availability" },
];
exports.columns = [
    { name: "Image", uid: "image_url" },
    { name: "SKU", uid: "sku" },
    { name: "PID", uid: "pid" },
    { name: "Title", uid: "title" },
    { name: "Price", uid: "price" },
    { name: "Available", uid: "availability" },
];
var ProductListTable = function (props) {
    var _a, _b, _c, _d, _e, _f;
    var dispatch = (0, react_redux_1.useDispatch)();
    var isExclusive = props.isExclusive, values = props.values, productsPerPage = props.productsPerPage, clientFilteredProducts = props.clientFilteredProducts, rowsPerPage = props.rowsPerPage, currentPage = props.currentPage, clientFilteredProductsPagination = props.clientFilteredProductsPagination, setProductsPerPage = props.setProductsPerPage, setValues = props.setValues, setCurrentPage = props.setCurrentPage, onPageChange = props.onPageChange, onPageChangeServerCall = props.onPageChangeServerCall;
    var client = (0, react_redux_1.useSelector)(function (state) { return state.clientState; }).client;
    var productsPerPageLength = isExclusive ? clientFilteredProductsPagination.countTotal : (_a = values === null || values === void 0 ? void 0 : values.product_list) === null || _a === void 0 ? void 0 : _a.length;
    var _g = (0, react_1.useState)(new Set([])), selectedKeys = _g[0], setSelectedKeys = _g[1];
    var tableColumnConfig = localStorage.getItem(local_storage_names_1.TABLE_COLUMN_CONFIG);
    var savedVisibleColumns = (_b = JSON.parse(tableColumnConfig)) !== null && _b !== void 0 ? _b : {};
    var initialVisibleColumns = (_c = savedVisibleColumns["productOptions"]) !== null && _c !== void 0 ? _c : constants_1.INITIAL_VISIBLE_COLUMNS;
    var _h = (0, react_1.useState)(new Set(initialVisibleColumns)), visibleColumns = _h[0], setVisibleColumns = _h[1];
    var _j = (0, react_1.useState)({
        column: "createdAt",
        direction: "ascending",
    }), sortDescriptor = _j[0], setSortDescriptor = _j[1];
    var updateValues = function (prop, value) {
        var _a;
        setValues(__assign(__assign({}, values), (_a = {}, _a[prop] = value, _a)));
    };
    (0, react_1.useEffect)(function () {
        var _a, _b;
        var isValidProductIdList = (_a = values === null || values === void 0 ? void 0 : values.product_list) === null || _a === void 0 ? void 0 : _a.every(function (product) { return typeof (product === null || product === void 0 ? void 0 : product._id) === "string" && (product === null || product === void 0 ? void 0 : product._id) !== null; });
        if (isValidProductIdList) {
            dispatch((0, get_products_shopify_thunk_1.get_client_filtered_products_thunk)(__assign(__assign({}, pages_1.filteredClientdealProductsInitialPaginationValues), { product_exception_list: (_b = values === null || values === void 0 ? void 0 : values.product_list) === null || _b === void 0 ? void 0 : _b.map(function (product) { return product === null || product === void 0 ? void 0 : product._id; }) })));
        }
    }, [(_d = values === null || values === void 0 ? void 0 : values.product_list) === null || _d === void 0 ? void 0 : _d.length]);
    (0, react_1.useEffect)(function () {
        var productsPerPage = (0, current_page_items_1.getCurrentPageProducts)(currentPage, rowsPerPage, values === null || values === void 0 ? void 0 : values.product_list);
        setProductsPerPage(productsPerPage);
    }, [rowsPerPage, currentPage, (_e = values === null || values === void 0 ? void 0 : values.product_list) === null || _e === void 0 ? void 0 : _e.length, values === null || values === void 0 ? void 0 : values.exclusive]);
    var renderCellViews = function (cellValue) {
        var _a;
        return [
            {
                key: "image_url",
                content: ((0, jsx_runtime_1.jsx)(react_2.User, { avatarProps: { radius: "lg", src: cellValue }, classNames: {
                        name: "text-default-foreground",
                        description: "text-default-500",
                    }, name: "" })),
            },
            {
                key: "sku",
                content: (0, jsx_runtime_1.jsx)(copy_text_1.CopyText, __assign({ className: "text-nowrap text-small capitalize text-default-foreground" }, { children: cellValue })),
            },
            {
                key: "pid",
                content: (0, jsx_runtime_1.jsx)("div", __assign({ className: "text-nowrap text-small capitalize text-default-foreground" }, { children: cellValue })),
            },
            {
                key: "title",
                content: (0, jsx_runtime_1.jsx)("div", __assign({ className: "text-nowrap text-small capitalize text-default-foreground" }, { children: cellValue })),
            },
            {
                key: "price",
                content: ((0, jsx_runtime_1.jsx)("div", __assign({ className: "text-nowrap text-small capitalize text-default-foreground" }, { children: lets_trade_utils_1.Formatting.formatMoney({
                        symbol: client === null || client === void 0 ? void 0 : client.currency_symbol,
                        value: (_a = cellValue === null || cellValue === void 0 ? void 0 : cellValue.toString()) !== null && _a !== void 0 ? _a : "0",
                        symbolSeparation: true,
                    }) }))),
            },
            {
                key: "availability",
                content: ((0, jsx_runtime_1.jsx)(react_2.Chip, __assign({ className: "text-nowrap text-small capitalize text-default-foreground", color: cellValue === "ONLINE" ? "success" : "danger", size: "sm", variant: "flat" }, { children: cellValue === "ONLINE" ? "Online" : "Offline" }))),
            },
        ];
    };
    var filterSelectedKeys = (0, react_1.useMemo)(function () {
        var resultKeys = new Set();
        resultKeys = selectedKeys;
        return resultKeys;
    }, [selectedKeys, productsPerPage]);
    var totalPages = (0, react_1.useMemo)(function () {
        var itemsCount = productsPerPageLength;
        return itemsCount ? Math.ceil(itemsCount / 5) : 0;
    }, [productsPerPageLength, values === null || values === void 0 ? void 0 : values.exclusive, 5, productsPerPage]);
    var processedProductsPerPage = productsPerPage === null || productsPerPage === void 0 ? void 0 : productsPerPage.map(function (item, index) { return (__assign(__assign({}, item), { fallbackKey: item._id || "fallback-key-".concat(index) })); });
    var handleProductSave = function (selectedProducts, tableID) {
        if (tableID === "product_list") {
            var updatedProducts_1 = __spreadArray([], values === null || values === void 0 ? void 0 : values.product_list, true);
            selectedProducts === null || selectedProducts === void 0 ? void 0 : selectedProducts.forEach(function (product) {
                var _a;
                if (!((_a = values === null || values === void 0 ? void 0 : values.product_list) === null || _a === void 0 ? void 0 : _a.some(function (existingProduct) { return (existingProduct === null || existingProduct === void 0 ? void 0 : existingProduct._id) === (product === null || product === void 0 ? void 0 : product._id); }))) {
                    updatedProducts_1 === null || updatedProducts_1 === void 0 ? void 0 : updatedProducts_1.push(product);
                }
            });
            updateValues("product_list", updatedProducts_1);
        }
    };
    var packageAheaderColumns = (0, react_1.useMemo)(function () {
        if (visibleColumns === "all")
            return exports.packageAcolumns;
        return exports.packageAcolumns
            .map(function (item) {
            if (item.uid === sortDescriptor.column) {
                return __assign(__assign({}, item), { sortDirection: sortDescriptor.direction });
            }
            return item;
        })
            .filter(function (column) { return Array.from(visibleColumns).includes(column.uid); });
    }, [visibleColumns, sortDescriptor]);
    var showAddProductsModal = function (tableID) {
        return dispatch((0, main_1.setContentModal)({
            title: "Add Products to Deal",
            content: (0, jsx_runtime_1.jsx)(add_products_component_1.default, { onSave: handleProductSave, onSelectAllProductsChange: function () { }, tableID: tableID }),
        }));
    };
    var onSelectionChange = (0, useMemoizedCallback_1.useMemoizedCallback)(function (keys) {
        var productList = [];
        if (keys === "all") {
            setSelectedKeys(keys);
        }
        else if (keys.size === 0) {
            setSelectedKeys(new Set());
        }
        else {
            var resultKeys_1 = new Set();
            keys.forEach(function (v) {
                resultKeys_1.add(v);
            });
            if (values === null || values === void 0 ? void 0 : values.exclusive) {
                productList = productsPerPage;
            }
            var selectedValue = selectedKeys === "all" ? new Set(productList.map(function (item) { return String(item._id); })) : selectedKeys;
            selectedValue.forEach(function (v) {
                if (productList.some(function (item) { return String(item._id) === v; })) {
                    return;
                }
                resultKeys_1.add(v);
            });
            setSelectedKeys(new Set(resultKeys_1));
        }
    });
    var removeSelectedProducts = function () { return __awaiter(void 0, void 0, void 0, function () {
        var updatedSelectedProducts;
        var _a;
        return __generator(this, function (_b) {
            if (selectedKeys === "all") {
                updateValues("product_list", []);
                return [2 /*return*/];
            }
            updatedSelectedProducts = (_a = values === null || values === void 0 ? void 0 : values.product_list) === null || _a === void 0 ? void 0 : _a.filter(function (product) { return !selectedKeys.has(product._id); });
            updateValues("product_list", updatedSelectedProducts);
            setCurrentPage(1);
            return [2 /*return*/];
        });
    }); };
    return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, table_top_bar_1.tableTopBar)({
                pageTitle: "Products",
                recordCount: isExclusive ? clientFilteredProductsPagination.countTotal : (_f = values === null || values === void 0 ? void 0 : values.product_list) === null || _f === void 0 ? void 0 : _f.length,
                actionButtons: [
                    {
                        label: "Add Products",
                        iconClassname: "solar:add-circle-bold",
                        onClick: function () {
                            showAddProductsModal("product_list");
                        },
                    },
                    {
                        label: "Remove Products",
                        iconClassname: "solar:minus-circle-bold",
                        onClick: function () {
                            removeSelectedProducts();
                        },
                    },
                ].filter(Boolean),
            }), (0, jsx_runtime_1.jsxs)(react_2.Table, __assign({ "aria-label": "product-list-table", bottomContent: (0, table_bottom_content_1.tableBottomContent)({
                    filterSelectedKeys: filterSelectedKeys,
                    page: isExclusive ? clientFilteredProductsPagination.page : currentPage,
                    pages: totalPages,
                    filteredItems: processedProductsPerPage,
                    onPreviousPage: function () { return onPageChange(currentPage - 1); },
                    onNextPage: function () { return onPageChange(currentPage + 1); },
                    setPage: isExclusive ? onPageChangeServerCall : onPageChange,
                }), bottomContentPlacement: "outside", classNames: {
                    td: "before:bg-transparent",
                }, selectedKeys: filterSelectedKeys, onSelectionChange: onSelectionChange, selectionMode: "multiple", topContentPlacement: "outside" }, { children: [(0, jsx_runtime_1.jsx)(react_2.TableHeader, __assign({ columns: packageAheaderColumns }, { children: function (column) { return ((0, jsx_runtime_1.jsx)(react_2.TableColumn, __assign({ align: column.uid === "actions" ? "end" : "start", className: (0, react_2.cn)([column.uid === "actions" ? "flex items-center justify-end px-[20px]" : ""]) }, { children: column.name }), column.uid)); } })), (0, jsx_runtime_1.jsx)(react_2.TableBody, __assign({ isLoading: false, emptyContent: "This table is empty.", items: isExclusive ? clientFilteredProducts : productsPerPage, loadingContent: (0, jsx_runtime_1.jsx)(react_2.Spinner, {}) }, { children: function (item) {
                            return ((0, jsx_runtime_1.jsx)(react_2.TableRow, { children: function (columnKey) { return ((0, jsx_runtime_1.jsx)(react_2.TableCell, { children: (0, jsx_runtime_1.jsx)(tabel_cell_1.TableCellComponent, { columnRecord: item, columnKey: columnKey, renderCellViews: function (cellValue) { return renderCellViews(cellValue); } }) })); } }, item === null || item === void 0 ? void 0 : item._id));
                        } }))] }))] }));
};
exports.ProductListTable = ProductListTable;
